import { SnackbarOrigin } from "@material-ui/core/Snackbar";

export const AUTH_TOKEN_KEY = "trailer_token";

export const PASSWORD_MIN_LENGTH = 8;

export const BACKEND_URL =
	process.env.REACT_APP_BACKEND_URL || "http://localhost:8081";

export const MAX_SNACK = 1;

export const REFRESH_DEFAULT_DELAY = 30000;

export const SNACKBAR_ORIGIN: SnackbarOrigin = {
	vertical: "top",
	horizontal: "center"
};

export const DATE_FORMAT = "YYYY. MM. DD.";
export const DATE_TIME_FORMAT = "YYYY. MM. DD. HH:mm";
export const DATE_PICKER_HEADER_FORMAT = "MM.DD. dddd";

export const datePickerConfig = {
	format: DATE_FORMAT,
	cancelLabel: "Mégse",
	showTodayButton: true,
	todayLabel: "Ma",
	invalidDateMessage: "A Dátum formátuma nem megfelelő",
	maxDateMessage: "A beírt dátum későbbi a megengedett maximálisnál",
	minDateMessage: "A beírt dátum régebbi a megengedett minimálisnál"
};
